// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/icons/coode-ai-robot-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.navbar-user-actions .user-name {
  border-bottom: 1px solid #cdcdcd;
  padding-bottom: 5px;
  position: relative;
  max-width: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.profile-action-icon {
  display: inline-block;
  width: 2.4rem;
  height: 2.4rem;
  vertical-align: top;
  background-color: currentColor;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  -webkit-mask-size: contain;
  mask-size: contain;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
